import {useServiceApiMutation} from 'stores/hooks/query';
import utils from 'helpers/utils';

const path = utils.servicePath(import.meta.url);

export function useClientStatusAdd (mutationOptions = {}) {
  return useServiceApiMutation(path, 'post', {}, {
    refetchContext: true,
    ...mutationOptions
  });
}

export function useClientStatusUpdate (mutationOptions = {}) {
  return useServiceApiMutation(path, 'patch', {}, mutationOptions);
}

export function useClientStatusReorder (mutationOptions = {}) {
  return useServiceApiMutation(path, 'post', {}, {
    overridePath: 'clients/:clientId/statuses/reorder', ...mutationOptions
  });
}

export function useClientStatusDelete (mutationOptions = {}) {
  return useServiceApiMutation(path, 'delete', {}, {
    refetchContext: true,
    ...mutationOptions
  });
}

